// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const wallSconce = defineModel({
  id: "wall-sconce",
  batchId: "future",
  name: "Wall sconce",
  tags: ["scenery","wall","sconce","low-poly","age-of-mcp","future"],
  summary: "A wall sconce — a bracket light fixed to a building wall.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.16,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.04, 0.2, 0.1), color: "#454b51", position: [-0.1, 0.4, 0] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.16, 6), color: "#2f343a", position: [-0.08, 0.4, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.08, 0.012, 4, 8, 2.243995), color: "#2f343a", position: [-0.02, 0.42, 0], rotation: [1.570796, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.12, 5), color: "#2f343a", position: [0.05, 0.46, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.03, 0.07, 8), color: "#23272b", position: [0.09, 0.54, 0] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#c43a20", position: [0.09, 0.56, 0] },
      { geometry: new THREE.ConeGeometry(0.055, 0.2, 6), color: "#ff8a2a", position: [0.09, 0.68, 0] },
      { geometry: new THREE.ConeGeometry(0.03, 0.24, 5), color: "#ffd24a", position: [0.095, 0.71, 0.005] },
    ],
  animations: [],
});
